import { render, staticRenderFns } from "./learner.vue?vue&type=template&id=54c7f03d&"
import script from "./learner.vue?vue&type=script&lang=js&"
export * from "./learner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports